import { makeVar } from "@apollo/client";

/**
 *
 */
export interface IRecommendationsCategorySelection {
  type: string;
  label: string;
}

export const recommendationsCategorySelectedVar = makeVar<string>("");
